"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var IconButton_1 = __importDefault(require("../../IconButton"));
var styles_1 = require("../../../styles");
var useStyles = (0, styles_1.makeStyles)(function (theme) { return ({
    close: {
        width: theme.spacing(4),
        height: theme.spacing(4)
    },
    error: {
        color: theme.palette.error.main
    },
    action: {
        color: theme.palette.primary.main
    }
}); });
var CloseButton = function (_a) {
    var _b = _a.text, text = _b === void 0 ? '' : _b, onClose = _a.onClose, _c = _a.isError, isError = _c === void 0 ? false : _c;
    var internalClasses = useStyles();
    return (react_1.default.createElement(IconButton_1.default, { kind: "close", key: "close", "aria-label": text, color: "inherit", onClick: onClose, classes: {
            button: { root: internalClasses.close },
            icon: { root: isError ? internalClasses.error : internalClasses.action }
        } }));
};
exports.default = CloseButton;
